import { Layer } from './layer';


import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import Feature from 'ol/Feature';
import Polygon, { fromExtent } from 'ol/geom/Polygon';
import { Style, Fill } from 'ol/style';
import { Circle } from 'ol/geom';


export class MaskLayer extends Layer {
 

    declare label: string;
    declare type: string;
    projection: string;
    maskType: string;
    coords: any;

    constructor(
        id: string,
        label: string,
        type: string,
        projection: string,
        maskType: string,
        coords: string
    ) {
        super(id, label, type);
        this.projection = projection;
        this.maskType = maskType;
        this.coords = coords;
    }

    toOlLayer() {
        let box: Polygon|any;

        switch (this.maskType) {
          case 'shape':
            box = this.coords;
            break;
          case 'circle':
            box = this.createCirclePointCoords(this.coords.center, this.coords.radius);
            break;
        }
    
        // const world = [[180, 90], [-180, 90], [-180, -90], [180, -90], [180, 90]];
        // const worldWithHole = new Polygon([world, box]).transform(this.projection, 'EPSG:3857');
    
        // var maskFeature = new Feature({
        //   geometry: worldWithHole,
        //   name: 'mask'
        // });
      
      const maskFeature = new Feature({
        geometry: fromExtent(box)
      });



    
        let source = new VectorSource({
          features: [maskFeature]
        });
    
        var olLayer = new VectorLayer({
          source: source,
          style: new Style({
            fill: new Fill({ color: [104, 4, 204, 0.8] })
          }),
         // zIndex: 1000,
        });
        olLayer.set('customId', this.id);
        
        return olLayer;
    }

    private createCirclePointCoords(center, radius) {
        const numberOfPoints = 72
        let coords = [];
        let angle = 0;
        for (let i = 0; i < numberOfPoints; i++) {
          angle = i * (360 / numberOfPoints);
          const circlePoint = this.drawCirclePoint(center, radius, angle);
          coords.push(circlePoint);
        }
        coords.push([coords[0][0], coords[0][1]]); // close the polygon
        return coords;
      }
    
      private drawCirclePoint(center, distance, bearing) {
        const radius = 6371; // earth radius (km)
    
        const δ = distance / radius; // angular distance in radian
        const θ = this.toRadian(bearing);
    
        const λ1 = this.toRadian(center[0]);
        const φ1 = this.toRadian(center[1]);
    
        const sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1);
        const sinδ = Math.sin(δ), cosδ = Math.cos(δ);
        const sinθ = Math.sin(θ), cosθ = Math.cos(θ);
    
        const sinφ2 = sinφ1 * cosδ + cosφ1 * sinδ * cosθ;
        const φ2 = Math.asin(sinφ2);
        const y = sinθ * sinδ * cosφ1;
        const x = cosδ - sinφ1 * sinφ2;
        const λ2 = λ1 + Math.atan2(y, x);
    
        return [
          (this.toDegrees(λ2) + 540) % 360 - 180, // normalize to -180...180°
          this.toDegrees(φ2)
        ]
    
      }
    
      private toRadian(deg: number) {
        return deg * Math.PI / 180;
      }
    
      private toDegrees(rad: number) {
        return rad * 180 / (Math.PI);
      }

}